import React from 'react';

import { Table, Collapse, TableBody, TableCell, TableRow } from '@material-ui/core';

import { CTPTAbleSubRow } from './CTPTAbleSubRow';
import { StyledExpandableSubRow } from './ExpandableSubRow.Styles';
import { ISkinsResults } from '../../../../../../Common/AssignResults/Context/AssignResults.context';

interface ICTPTAbleExpansableSubRowProps {
  hole: string;
  index: number;
  ctpResults: ISkinsResults;
  expandRow: (rowIndex: number) => () => void;
  roundId: number;
  collapsedRow?: number;
}

export const CTPTAbleExpandableSubRow: React.FunctionComponent<
  ICTPTAbleExpansableSubRowProps
> = props => {
  const { hole, index, ctpResults, expandRow, collapsedRow, roundId } = props;

  return (
    <TableRow className="expandable-row" key={`hiddenTableRow-${index}`}>
      <TableCell
        className="inner-cell"
        colSpan={4}
        classes={{ root: 'leaderboard-row-event-summary' }}
      >
        <StyledExpandableSubRow>
          <Collapse
            className={`collapse-${index}`}
            classes={{
              container: 'leaderboard-collapse',
              wrapperInner: 'leaderboard-collapse__wrapper-inner override'
            }}
            in={collapsedRow === index}
            timeout="auto"
            unmountOnExit={true}
          >
            <Table className="table">
              <colgroup>
                {[0, 1, 2].map(colIndex => (
                  <col key={colIndex} />
                ))}
              </colgroup>
              <TableBody>
                <TableRow className="table-subheader" />
                {ctpResults[Number(hole)].map((player, expandedIndex: number) => (
                  <CTPTAbleSubRow
                    holeResult={player}
                    hole={hole}
                    index={expandedIndex}
                    expandRow={expandRow}
                    isSubRow={true}
                    roundId={roundId}
                  />
                ))}
              </TableBody>
            </Table>
          </Collapse>
        </StyledExpandableSubRow>
      </TableCell>
    </TableRow>
  );
};
